import { useEffect, useState } from 'react'
import { Avatar, Box, Divider, Grid, Flex, useToast } from '@chakra-ui/react'
import DsrCreatePostTypeButton from '../dsr-create-post/DsrCreatePostTypeButton'
import { DsrLoomRecordButton } from '../dsr-record-content/DsrLoomRecordButton'

import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import { isValidArray, triggerLaunchdeckToast } from '../../global/helpers/global-helpers'
import { BiEditAlt } from 'react-icons/bi'


function DsrCreateContentPostModule({
  userProfile,
  handleOpenNewPostModal,
  handleSelectSubpage,
  handleCreateNewPost,
  isMobileView,
  processingNewDsrPosts
}) {

  const { memberName, memberProfilePicSrc } = userProfile || {};
  const [isLoading, setIsLoading] = useState(null)
  const toast = useToast();

  useEffect(() => {
    if (processingNewDsrPosts) {
      if (isValidArray(processingNewDsrPosts)) {
        setIsLoading(true)
      } else {
        setIsLoading(false)
      }

    }
  }, [processingNewDsrPosts])

  const sendCurrentlyProcessingPrompt = () => {
    toast(
      triggerLaunchdeckToast({
        useCase: "work-in-progress-state",
        label: "Please give us a moment to finish working on a post you've just created.",
        isMobileView,
        duration: 5000
      })
    )
  }

  const renderUserOptions = () => {
    if (isMobileView) {
      return (
        <Flex justify='space-between' align='center'>
          <Grid templateColumns="repeat(2, 1fr)" mb={isMobileView ? '0em' : '1em'} mt='1.5em' width='100%' flexWrap='wrap' fontSize='0.8em'>
            <DsrCreatePostTypeButton type='write-post' handleOpenNewPostModal={() => handleOpenNewPostModal("create-new-post")} />
            <DsrCreatePostTypeButton type='ask-question' handleOpenNewPostModal={handleOpenNewPostModal} isMobileView={isMobileView} />
          </Grid>
        </Flex>
      )
    } else {
      return (
        <Flex justify='space-between' align='center'
          cursor={isLoading && "pointer"}
          onClick={() => {
            if (isLoading) {
              sendCurrentlyProcessingPrompt();
            }
          }}
        >
          <Box
            width="100%"
            opacity={isLoading ? 0.5 : 1}
            pointerEvents={isLoading ? "none" : "auto"}
          >
            <Grid templateColumns="repeat(4, 1fr)" mt='1em' width='100%' flexWrap='wrap' fontSize='0.875em' gap='1em'>
              <DsrCreatePostTypeButton type='write-post' handleOpenNewPostModal={() => handleOpenNewPostModal("create-new-post")} />
              <DsrCreatePostTypeButton type='ask-question' handleOpenNewPostModal={handleOpenNewPostModal} />
              <DsrCreatePostTypeButton type='create-action-item' handleSelectSubpage={handleSelectSubpage} />
              <Flex display={['none', 'flex']} justify='center'>
                <DsrLoomRecordButton
                  handleCreateNewPost={handleCreateNewPost}
                  sending={false}
                  submitRecording={(v) => { }}
                  displayClassName='create-post-button'
                />
              </Flex>

              {/* Use More dropdown menu if there are more options to collapse it into */}
              {/* <DsrCreatePostTypeButton type='post-poll' handleOpenNewPostModal={handleOpenNewPostModal}/> */}
              {/* <DsrCreatePostTypeButton type='make-voice-post' handleOpenNewPostModal={handleOpenNewPostModal}/> */}
            </Grid>
          </Box>
        </Flex>
      )
    }
  }



  return (
    <>
      <Box p='1em' w='100%' bg='white' rounded='0.25em' border='1px solid' borderColor='gray.300'>
        <Flex mt='0.625em' justify='flex-start' width='100%'>
          <Box px='0.5em'>
            <Avatar h='4.2em' w='4.2em' name={memberName} bg='gray.100' color='gray.700' src={memberProfilePicSrc ? memberProfilePicSrc : ""} />
          </Box>

          <Flex
            px='0.5em'
            width='100%'
            border='1px solid' borderColor='gray.400'
            rounded='0.25em'
            cursor='pointer'
            gap='0.5em'
            align='center'

            onClick={() => {
              if (isLoading) {
                sendCurrentlyProcessingPrompt();
              } else {
                handleOpenNewPostModal("create-new-post")
              }
            }}>
            <Box as={BiEditAlt} color='gray.500' boxSize="1em" />
            <Box color='gray.500' px='0.8em' py='0.5em' fontSize='0.875em'>{isMobileView ? "Share your thoughts" : "What are you thinking about?"}</Box>
          </Flex>
        </Flex>

        {renderUserOptions()}

      </Box>

      <Divider mt='1.5em' mb='0.5em' />

    </>
  );

}



function mapStateToProps(state) {
  return {
    isMobileView: state.mobileViewMode.isMobileView
  };
}

export default withRouter(connect(mapStateToProps, null)(DsrCreateContentPostModule))